import styled from 'styled-components'

const StyledResetPasswordView = styled.div`
  
`

export default StyledResetPasswordView
